import SignInForm from '@/components/auth/SignInForm';
import { AuthCardContainer, AuthPageContainer, Background, CentreContainer } from '@/components/auth/Styles';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { Stack } from '@montugroup/design-system';
import { BrandThemeProvider } from '@montugroup/themes';

function SignIn() {
  const { key: brandName, Icon: Bg, Logo: TopLogo } = usePortalPartnerBrand();

  return (
    <BrandThemeProvider theme={brandName}>
      <AuthPageContainer>
        <CentreContainer>
          <AuthCardContainer>
            <Stack mb={10}>
              <TopLogo width="150px" height="auto" fillColor={(theme) => theme.palette.primary.main} />
            </Stack>
            <SignInForm />
          </AuthCardContainer>
        </CentreContainer>
      </AuthPageContainer>
      <Background>
        <Bg />
      </Background>
    </BrandThemeProvider>
  );
}

export default SignIn;
